module.exports = __webpack_public_path__ + "img/IMG_0852.765e86db.jpg";